module.exports = __webpack_public_path__ + "static/img/share_with_bg.7cd07d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/invitation/share_with_bg.png
// module id = oQdJ
// module chunks = 1